import { generateSkinDefaults } from '@wix/editor-elements-panel';
import { stylableButtonSkinDefinitionMap } from '../../StylableButton/StylableButton.skinParams';

export const hamburgerCloseButtonSkin = 'wixui.skins.HamburgerCloseButton';

export const hamburgerCloseButtonSkinDefinition = {
  [hamburgerCloseButtonSkin]:
    stylableButtonSkinDefinitionMap['wixui.skins.StylableButton'],
};

export default generateSkinDefaults(hamburgerCloseButtonSkinDefinition);
